import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { ApiVisa, Core2Config, Pagination, PagingResponseModel } from '../../shared';
import { Observable } from 'rxjs';

//https://api.akaun.cloud/core2/tnt/dm/erp/inv/txn-line/stock-cards/detail/backoffice-ep

@Injectable({ providedIn: 'root' })

export class InventoryStockCardDetailsService extends BaseApiTemplateService<any> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.INV_PREFIX + 'txn-line/stock-cards/detail/backoffice-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.INV_PREFIX + 'txn-line/stock-cards/detail/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.INV_PREFIX + 'txn-line/stock-cards/detail/backoffice-ep';
    this.httpClient = http;
  }

  public getTxnLine(pagination: Pagination, visa: ApiVisa):
    Observable<PagingResponseModel<any>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl  + '?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<any>>
      (url, this.getHttpHeader(visa));
  }
}
